import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconFire, IconGift } from '../../elements/Icon';

const WEEK_DAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

function getLast35Days() {
    const result = [];

    const today = new Date();

    const currentDay = today.getUTCDay();
    const daysUntilSaturday = 6 - currentDay;

    const lastSaturday = new Date(today);
    lastSaturday.setUTCDate(today.getUTCDate() + daysUntilSaturday);

    for (let i = 34; i >= 0; i--) {
        const d = new Date(lastSaturday);
        d.setUTCDate(lastSaturday.getUTCDate() - i);

        const key = d.toISOString().split('T')[0];

        const isFuture = d > today;

        result.push({
            key,
            day: d.getUTCDate(),
            weekDay: WEEK_DAYS[d.getUTCDay()],
            isFuture,
        });
    }

    return result;
}

export const Strike = ({ onClose, countStrike, dailyScore }) => {
    const { t } = useTranslation();

    const storage = countStrike || localStorage.getItem('streak');

    const scores = dailyScore || [];

    const enabledDates = useMemo(() => {
        return new Set(
            scores
                .filter(item => item?.date)
                .map(item => item.date)
        );
    }, [scores]);

    const days = useMemo(() => {
        return getLast35Days().map((item) => ({
            ...item,
            enabled: !item.isFuture && enabledDates.has(item.key),
        }));
    }, [enabledDates]);

    return (
        <div
            onClick={onClose}
            className="w-full h-full absolute z-[60] bg-black/30 flex justify-center items-center"
        >

            <div
                onClick={(e) => e.stopPropagation()}
                className="
                relative
                xl:w-[896px] lg:w-[656px] md:w-[540px] sm:w-[516px] w-[336px]
                xl:h-[466px] lg:h-[336px] md:h-[283px] sm:h-[265px] h-[538px]
                xl:px-[36px] lg:px-[24px] md:px-[16px] px-[10px]
                rounded-[19px]
                border-[4px]
                border-[#7743BA]
                bg-[#F8F4EA]
                shadow-xl
        "
            >


                <div className="flex items-center justify-center gap-2
                xl:mt-[34.5px] lg:mt-[20.5px] md:mt-[23px] sm:mt-[8px] mt-[23.5px]
                xl:mb-[48.5px] lg:mb-[28.5px] md:mb-[22px] sm:mb-[24px] mb-[30.5px]
                ">
                    <h2 className="text-[#4B96C9]
            xl:text-[36px] lg:text-[26px] md:text-[24px] text-[20px]
            text-center
            font-fredokaOne">
                        {t("day_streak").replace("X", storage)}
                    </h2>

                    <IconFire className="xl:w-[30px] w-[19px]" />
                </div>

                <div className="flex sm:flex-row flex-col relative justify-center">

                    {/* Left block */}
                    <div className="flex-1 ">
                        <div className="grid grid-cols-7 justify-center justify-items-center">
                            {WEEK_DAYS.map((day) => (
                                <div
                                    key={day}
                                    className="text-center lg:h-[23px] h-[19px] xl:w-[44px] lg:w-[32px] w-[26px]
                                    text-[10px] xl:text-[16px] text-[#9F96A9] font-medium"
                                >
                                    {day}
                                </div>
                            ))}
                        </div>

                        <div className="grid grid-cols-7 xl:mt-[12px] lg:mt-[8px] mt-[4px] justify-items-center">
                            {days.map((item) => (
                                <div
                                    key={item.key}
                                    className={`
                                            xl:h-[44px] lg:h-[32px] sm:h-[26px] h-[32px]
                                            xl:w-[44px] lg:w-[32px] sm:w-[26px] w-[32px]
                                            xl:mb-[10px] mb-[8px]
                                            rounded-[4px]
                                            flex
                                            items-center
                                            justify-center
                                            xl:text-[20px]
                                            text-[16px]
                                            ${item.isFuture
                                            ? 'bg-transparent text-[#000]'
                                            : item.enabled
                                                ? 'bg-[#7743BA] text-white'
                                                : 'bg-[#BAA8D2] text-white'}
                                                `}
                                >
                                    {item.day}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Line */}
                    <div className="
                                    shrink-0

                                    border-b-4 border-[#ACC587] w-[328px]  h-0

                                    sm:border-b-0 sm:border-r-4 sm:w-auto sm:h-auto sm:self-stretch

                                    xl:mx-[40px]
                                    lg:mx-[28px]
                                    md:mx-[20px]
                                    sm:mx-[14px]
                                    
                                    ml-[-10px]

                                    xl:mb-[-16px]
                                    lg:mb-[-9px]
                                    md:mb-[-1px]
                                    sm:mb-[4px]
                                    mb-[2px]

                                    sm:mt-[0px]
                                    mt-[16px]

                                    xl:mt-[34px]
                                    lg:mt-[30px]
                                    sm:mt-[22px]

                                    
                                    "
                    />

                    {/* Right block */}
                    <div
                        className="
                                   grid
                                   grid-cols-[repeat(2,max-content)]
                                   sm:justify-start
                                   justify-center
                                   xl:gap-[20px]
                                   lg:gap-[16px]
                                   gap-[14px]
                                   xl:mt-[33px]
                                   lg:mt-[30px]
                                   mt-[22px]
                                   xl:h-[260px] lg:h-[192px] md:h-[162px] h-[168px]
                                 "
                    >
                        <div className="border-2 border-[#B2ABBC] rounded-[10px]  flex flex-col items-center
                                        xl:w-[174px] lg:w-[128px] sm:w-[108px] w-[128px]
                                        xl:h-[120px] lg:h-[88px] h-[74px]
                                        ">
                            <p className="text-[#4B96C9] xl:text-[20px] text-[16px] font-fredokaOne xl:mt-[12px] mt-[12px] xl:mb-[22px] lg:mb-[13px] mb-[6px]">
                                2-3 days
                            </p>

                            <div className="flex items-center gap-1 text-[#4B96C9] font-bold font-commisioner xl:text-[20px] text-[16px]">
                                +1
                                <IconGift className="xl:w-[40px] lg:w-[26px] md:w-[22px] w-[24px]" />
                            </div>
                        </div>

                        <div className="border-2 border-[#B2ABBC] rounded-[10px]  flex flex-col items-center
                                        xl:w-[174px] lg:w-[128px] sm:w-[108px] w-[128px]
                                        xl:h-[120px] lg:h-[88px] h-[74px]
                                        ">
                            <p className="text-[#4B96C9] xl:text-[20px] text-[16px] font-fredokaOne xl:mt-[12px] mt-[12px] xl:mb-[22px] lg:mb-[13px] mb-[6px]">
                                4-6 days
                            </p>

                            <div className="flex items-center gap-1 text-[#4B96C9] font-bold font-commisioner xl:text-[20px] text-[16px]">
                                +3
                                <IconGift className="xl:w-[40px] lg:w-[26px] md:w-[22px] w-[24px]" />
                            </div>
                        </div>

                        <div className="border-2 border-[#B2ABBC] rounded-[10px]  flex flex-col items-center
                                        xl:w-[174px] lg:w-[128px] sm:w-[108px] w-[128px]
                                        xl:h-[120px] lg:h-[88px] h-[74px]
                                        ">
                            <p className="text-[#4B96C9] xl:text-[20px] text-[16px] font-fredokaOne xl:mt-[12px] mt-[12px] xl:mb-[22px] lg:mb-[13px] mb-[6px]">
                                7-9 days
                            </p>

                            <div className="flex items-center gap-1 text-[#4B96C9] font-bold font-commisioner xl:text-[20px] text-[16px]">
                                +4
                                <IconGift className="xl:w-[40px] lg:w-[26px] md:w-[22px] w-[24px]" />
                            </div>
                        </div>

                        <div className="border-2 border-[#B2ABBC] rounded-[10px]  flex flex-col items-center
                                        xl:w-[174px] lg:w-[128px] sm:w-[108px] w-[128px]
                                        xl:h-[120px] lg:h-[88px] h-[74px]
                                        ">
                            <p className="text-[#4B96C9] xl:text-[20px] text-[16px] font-fredokaOne xl:mt-[12px] mt-[12px] xl:mb-[22px] lg:mb-[13px] mb-[6px]">
                                +10 days
                            </p>

                            <div className="flex items-center gap-1 text-[#4B96C9] font-bold font-commisioner xl:text-[20px] text-[16px]">
                                +5
                                <IconGift className="xl:w-[40px] lg:w-[26px] md:w-[22px] w-[24px]" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
